import {createSelector} from 'reselect';

import {AppSelector} from '../../../../helpers/reselectHelpers';
import {getUserId} from '../../../data/teammates/teammatesSelectors';
import {getCellsPanel} from '../../panelsSelectors';
import {CellsPanelSearchResultsCounts, DEFAULT_SEARCH_RESULTS_COUNTS} from './cellsPanelSearchState';

export const getCellsSearchResultsCounts: AppSelector<CellsPanelSearchResultsCounts> = createSelector(
  [getCellsPanel],
  (maybeCellsPanel) => {
    if (!maybeCellsPanel) {
      return DEFAULT_SEARCH_RESULTS_COUNTS;
    }

    return maybeCellsPanel.search.resultsCounts;
  },
);

export const getCellsSearchSessionTimestamp = createSelector(
  getCellsPanel,
  (maybeCellsPanel) => maybeCellsPanel?.search?.searchSessionTimestamp,
);

export const getCellsSearchQueryHash = createSelector(
  [getUserId, getCellsPanel],
  (userId, maybeCellsPanel) => {
    // Sanity check to avoid using a malformed query hash.
    if (!maybeCellsPanel?.search?.searchSessionTimestamp) {
      return undefined;
    }

    return `${userId}-${maybeCellsPanel.search.searchSessionTimestamp}`;
  },
);

export const getCellsSearchRecentQueries = createSelector(
  getCellsPanel,
  (maybeCellsPanel) => maybeCellsPanel?.search?.recentQueries,
);

export const getCellsSearchSuggestions = createSelector(
  getCellsPanel,
  (maybeCellsPanel) => maybeCellsPanel?.search?.suggestions,
);

export const getCellsSearchHints = createSelector(
  getCellsPanel,
  (maybeCellsPanel) => maybeCellsPanel?.search?.hints,
);

export const getCellsSearchHighlightAlgorithm = createSelector(
  getCellsPanel,
  (maybeCellsPanel) => maybeCellsPanel?.search.highlightAlgorithm,
);
